import { connect } from 'react-redux';
import ViziaComponent from '../components/ViziaComponent.jsx';
import {
  getConfig,
  getComponentById,
  getFolderByComponentId,
  getOtp,
} from '../selectors/index.js';

const mapStateToProps = (state, props) => {
  return Object.assign({
    folderOptions: getFolderByComponentId(state, props).options,
    config: getConfig(state),
    colors: state.colors,
    otp: getOtp(state),
  }, getComponentById(state, props));
};

export default connect(mapStateToProps)(ViziaComponent);
